import { Box, Button, Flex, Select, Text } from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import AppConfig from "config";
import FichasController from "controllers/Fichas/FichasController";
import RelatoriosController from 'controllers/Relatorios/RelatoriosController';
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from 'sweetalert2';
import { local } from "../../../components/Datebr/datebr";
window.Swal = swal;
const classDatepicker = `
  .datepickers {
    background-color: #e7e7e7;
    border-radius: 3px;
    color:black;
  }
`;
function ExtracoesView() {
  const [csvLink, setCsvLink] = useState(null);
  const [auditId, setAuditId] = useState('');
  const [csvLink_2, setCsvLink_2] = useState(null);
  const [fichas, setFichas] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState('');
  const [selectedFicha_2, setSelectedFicha_2] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDate2, setStartDate2] = useState(null);
  const [endDate2, setEndDate2] = useState(null);
  const jwtToken = localStorage.getItem('access_token');
  

  useEffect(() => {
    async function fetchFichas() {
      try {
        const response = await FichasController.ListFichas();
        if (response) {
          setFichas(response);
        } else {
          console.error('Erro ao buscar fichas:', response.status);
        }
      } catch (error) {
        console.error('Erro ao buscar fichas:', error);
      }
    }

    fetchFichas();
  }, []);
  
  useEffect(() => {
    if (fichas.length > 0) {
      setSelectedFicha(fichas[0].Nome);
      setSelectedFicha_2(fichas[0].Nome);
      setAuditId(fichas[0].id.toString());
    }
  }, [fichas]);

  const extrairDados = async () => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon: "info",
      title: "Aguarde o download"
    });
    
    setCsvLink("");
    setStartDate(null);
    setEndDate(null);
    try {
      if ((!startDate && !endDate) || (startDate && endDate && endDate >= startDate)) {
        const formattedStartDate = startDate ? startDate.toISOString().split('T')[0] : '';
        const formattedEndDate = endDate ? endDate.toISOString().split('T')[0] : '';

        const url = AppConfig.BACKEND_URL + `/nova_extracao?audit_id=${auditId}&ini=${formattedStartDate}&fim=${formattedEndDate}`;
        const token = jwtToken
        const headers = {
          Authorization: `Bearer ${token}`
        };
        
        const response = await fetch(url, {
          headers: headers
        });

        if (response.ok) {
          const csvFile = await response.blob();
          const url = window.URL.createObjectURL(new Blob([csvFile]));
          setCsvLink(url);
        } else {
          console.error('Erro ao extrair dados:', response.status);
          Toast.fire({
            icon: "error",
            title: "Não há extrações existentes! Selecione outra ficha"
          });
        }
      } else {

        Toast.fire({
          icon: "error",
          title: "Por favor, selecione uma data final maior ou igual à data inicial."
        });
      }
    } catch (error) {
      console.error('Erro ao extrair dados:', error);

      Toast.fire({
        icon: "error",
        title: "Não foi possível extrair os dados para extração. Verifique e tente novamente."
      });
    }
  };

  const extrairDados_2 = async () => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon: "info",
      title: "Aguarde o download"
    });
    setCsvLink_2('');
    setStartDate2(null);
    setEndDate2(null);
    try {
      if ((!startDate2 && !endDate2) || (startDate2 && endDate2 && endDate2 >= startDate2)) {
        const formattedStartDate = startDate2 ? startDate2.toISOString().split('T')[0] : '';
        const formattedEndDate = endDate2 ? endDate2.toISOString().split('T')[0] : '';

        const url = await RelatoriosController.ListResultsQuestions(auditId, formattedStartDate, formattedEndDate)

        if (url) {
          const csv = window.URL.createObjectURL(new Blob([url]));
          setCsvLink_2(csv);
        } else {
          console.error('Erro ao extrair dados:', response.status);

          Toast.fire({
            icon: "error",
            title: "Não foi possível extrair os dados para extracao. Verifique e tente novamente."
          });
        }
      } else {
        Toast.fire({
          icon: "error",
          title: "Por favor, selecione uma data final maior ou igual à data inicial."
        });
      }
    } catch (error) {
      console.error('Erro ao extrair dados:', error);
      Toast.fire({
        icon: "error",
        title: "Não foi possível extrair os dados para extração. Verifique e tente novamente."
      });
    }
  };

  const handleSelectChange = (event) => {
    setSelectedFicha(event.target.value);
    const selected = fichas.find((ficha) => ficha.Nome === event.target.value);
    if (selected) {
      setAuditId(selected.id.toString());
      setCsvLink(null);
      setStartDate(null);
      setEndDate(null);
    } else {
      setSelectedFicha('');
      setAuditId('');
      setCsvLink(null);
    }
  };

  const handleSelectChange_2 = (event) => {
    setSelectedFicha_2(event.target.value);
    const selected = fichas.find((ficha) => ficha.Nome === event.target.value);
    if (selected) {
      setAuditId(selected.id.toString());
      setCsvLink_2(null);
      setStartDate2(null);
      setEndDate2(null);
    } else {
      setSelectedFicha_2('');
      setAuditId('');
      setCsvLink_2(null);
    }
  };

  const centerContentStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };


  return (
    <Flex direction='column' height="100%" width="100%">
      <style>{classDatepicker}</style>
      <Flex direction='row' alignItems='center' height="100%">
        <Card>
          <CardHeader __css={centerContentStyles}>
            <Flex direction='column' alignItems='center'>
              <Text fontSize='xl' fontWeight='bold' mb={2}>
                Analítico de transcrições
              </Text>
              <Text fontSize='md' fontWeight='bold'>
                Selecione uma ficha
              </Text>
              <Select value={selectedFicha} onChange={handleSelectChange} mt={2}>
                {fichas.map((ficha) => (
                  <option key={ficha.id} value={ficha.Nome}>
                    {ficha.Nome}
                  </option>
                ))}
              </Select>
              <Flex alignItems='center' mt={4}>
                <Box>
                  <Text>Início:</Text>
                  <DatePicker
                    locale={local}
                    selected={startDate}
                    onChange={date => setStartDate(date)}
                    className={"datepickers"}
                    calendarClassName="customCalendar"
                    dateFormat="dd/MM/yyyy"
                  />
                </Box>
                <Box ml={4}>
                  <Text>Fim:</Text>
                  <DatePicker
                    locale={local}
                    selected={endDate}
                    onChange={date => setEndDate(date)}
                    className={"datepickers"}
                    calendarClassName="customCalendar"
                    dateFormat="dd/MM/yyyy"
                  />
                </Box>
              </Flex>
              <Button onClick={extrairDados} colorScheme='blue' mt={4}>
                Extrair dados
              </Button>
              {csvLink && (
                <a href={csvLink} download='dados_extraidos.csv'>
                  Download
                </a>
              )}
            </Flex>
          </CardHeader>
        </Card>

        <Card>
          <CardHeader __css={centerContentStyles}>
            <Flex direction='column' alignItems='center'>
              <Text fontSize='xl' fontWeight='bold' mb={2}>
                Analítico de perguntas
              </Text>
              <Text fontSize='md' fontWeight='bold'>
                Selecione uma ficha
              </Text>
              <Select value={selectedFicha_2} onChange={handleSelectChange_2} mt={2}>
                {fichas.map((ficha) => (
                  <option key={ficha.id} value={ficha.Nome}>
                    {ficha.Nome}
                  </option>
                ))}
              </Select>
              <Flex alignItems='center' mt={4}>
                <Box>
                  <Text>Início:</Text>
                  <DatePicker
                    locale={local}
                    selected={startDate2}
                    onChange={date => setStartDate2(date)}
                    className={"datepickers"}
                    calendarClassName="customCalendar"
                    dateFormat="dd/MM/yyyy"
                  />
                </Box>
                <Box ml={4}>
                  <Text>Fim:</Text>
                  <DatePicker
                    locale={local}
                    selected={endDate2}
                    onChange={date => setEndDate2(date)}
                    className={"datepickers"}
                    calendarClassName="customCalendar"
                    dateFormat="dd/MM/yyyy"
                  />
                </Box>
              </Flex>
              <Button onClick={extrairDados_2} colorScheme='blue' mt={4}>
                Extrair dados
              </Button>
              {csvLink_2 && (
                <a href={csvLink_2} download='segundos_dados_extraidos.csv'>
                  Download
                </a>
              )}
            </Flex>
          </CardHeader>
        </Card>
      </Flex>
    </Flex>
  );
}

export default ExtracoesView;